import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from '@/router/guards/authGuard.ts'
import { guestGuard } from '@/router/guards/guestGuard.ts'
import { routes } from '@/router/routes.ts'
import { reloadOnceOnDynamicImportLoadError } from '@/helpers/chunkLoadError.ts'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.meta.isPublicRoute) {
        return next()
    }

    if (to.meta.isGuestRoute) {
        return guestGuard(to, from, next)
    }

    return authGuard(to, from, next)
})

router.onError((error) => {
    reloadOnceOnDynamicImportLoadError(error)
})

export default router
